import React from 'react';
import Toggle from 'react-toggle';
import './BulkFundingCard.scss';
import { CardFundingProps } from 'app/interfaces/marketplace/marketplace.interface';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import { useParams } from 'react-router-dom';
// import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';

  type FundingCardProps = {
    fundingData: Partial<CardFundingProps>;
  };
const BulkFundingCard = function init(props: FundingCardProps): React.ReactElement {
    const {
        fundingData
    } = props;
    const { upload_secure_id } = useParams<{ upload_secure_id: string }>();

    function getInterestPercentage(): number {
      const { interestPercentage, interest } = fundingData;
      if (interestPercentage) {
        return interestPercentage * 100;
      }
      if (interest) {
        return interest * 100;
      }
      return 0;
    }

    function getLoanType(): string {
      const { loanTypeName, loan_type_name } = fundingData;
      if (loanTypeName) {
        return loanTypeName;
      }
      if (loan_type_name) {
        return loan_type_name;
      }
      return '-';
    }

    function getTotalFunding(): string {
      const { totalFunding, total_funding } = fundingData;
      if (totalFunding) {
        return rupiahCurrencyFormatter(totalFunding);
      }
      if (total_funding) {
        return rupiahCurrencyFormatter(total_funding);
      }
      return 'Rp0';
    }

    function getRating(): string {
		const { grade } = fundingData;
		if (!('grade' in fundingData)) {
			return '';
		}
		if (grade) {
			return grade;
		}
		return '-';
	}

    function getProgress(): number {
      const { totalFunding, totalLoanAmount, progress_percentage } = fundingData;
      if (totalFunding && totalLoanAmount) {
        return ((totalFunding / totalLoanAmount) * 100) || 0;
      }
      return progress_percentage || 0;
    }

    function footerContent(): React.ReactElement {
      return (
        <div className="footer">
          <div className="d-flex toggle-wrapper">
            <Toggle
                disabled
                checked
                icons={false}
            />
          </div>

          <input
							className="input-group"
							name="funding-amount"
							disabled
							value={getTotalFunding()}
          />
        </div>
      );
    }

    return (
        <div className="bulk-funding-card">
          <div className="header">
            <span className="product-name">
                {getLoanType()}
            </span>
            <span className="product-id">
                {fundingData.uploadTransactionNumber}
            </span>
          </div>
          <div className="main-content">
            <div className="interest-rate">
              <h2>
                {getInterestPercentage()}
                %
              </h2>
            </div>
            {
              fundingData.max_funding && (
                <div>
                  <div className="label">Sisa Pendanaan</div>
                  <span>{rupiahCurrencyFormatter(fundingData.max_funding)}</span>
                </div>
              )
            }
            {
              fundingData.loan_number && (
                <div>
                  <div className="label">Nomor Pinjaman</div>
                  <span>{fundingData.loan_number}</span>
                </div>
              )
            }
            {
              fundingData.tenure && (
                <div>
                  <div className="label">Tenor</div>
                  <span>{fundingData.tenure}</span>
                </div>
              )
            }
            {
              fundingData.minimum_funding && (
                <div>
                  <div className="label">Minimum Pendanaan</div>
                  <span>{rupiahCurrencyFormatter(fundingData.minimum_funding)}</span>
                </div>
              )
            }
            <div>
                <div className="label">Total Pendanaan</div>
                <span>
                    {rupiahCurrencyFormatter(fundingData.totalLoanAmount || fundingData.target_funding || 0)}
                </span>
            </div>
            {
              fundingData.totalLoan && (
                <div>
                  <div className="label">Jumlah Pinjaman</div>
                  <span>{fundingData.totalLoan}</span>
                </div>
              )
            }
			{getRating() && (
            <div className="rating">
                <div className="label">Rating</div>
                <span className="rating-badge">{getRating()}</span>
            </div>
			)}
            {
              fundingData.purpose && (
                <div>
                  <div className="label">Ket. Pinjaman</div>
                  <span>{fundingData.purpose}</span>
                </div>
              )
            }
          </div>
          <div className="progress-section">
            <div>Perkembangan Pendanaan</div>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${getProgress()}%` }}
              >
                <span className="progress-text">
                    {getProgress()}
                    %
                </span>
              </div>
            </div>
            <div className="progress-values">
              <span>{getTotalFunding()}</span>
              <span>{rupiahCurrencyFormatter(fundingData.totalLoanAmount || fundingData.target_funding || 0)}</span>
            </div>
          </div>

          {upload_secure_id && footerContent()}
        </div>
      );
  };
export default BulkFundingCard;
